import {z} from 'zod';

export const GridMappingSchema = z.object({
  columnMappings: z
    .array(
      z.object({
        sourceFieldID: z.number().nullable(),
        sourceFieldText: z.string().nullable(),
        typeID: z.string().nullable(),
        typeText: z.string().nullable(),
        destinationID: z.number().nullable(),
        destinationText: z.string().nullable(),
        mandatory: z.boolean(),
        isNewRow: z.boolean(),
        clientUniqueIdentifierRow: z.number(),
      })
    )
    .superRefine((mappings, ctx) => {
      // Validate mandatory rows have all fields selected
      mappings.forEach((mapping, idx) => {
        if (mapping.mandatory) {
          if (!mapping.sourceFieldID) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              path: [idx, 'sourceFieldID'],
              message: 'Source Field is required for mandatory rows',
            });
          }
          if (!mapping.typeID || mapping.typeID === 'Select') {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              path: [idx, 'typeID'],
              message: 'Type is required for mandatory rows',
            });
          }
          if (!mapping.destinationID || mapping.destinationID === 0) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              path: [idx, 'destinationID'],
              message: 'Destination Field is required for mandatory rows',
            });
          }
        }
      });
    }),
});

export type GridFormValues = z.infer<typeof GridMappingSchema>;
